// src/pages/admin/DepartmentListPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; 
import { useDepartment } from '../../contexts/DepartmentContext';
import DepartmentList from '../../components/departments/DepartmentList';

function DepartmentListPage() {
  const { t } = useTranslation('departments'); 
  const { t: tCommon } = useTranslation('common'); 
  
  const { departments, loading, error, addDepartment } = useDepartment();
  const [newDepartmentName, setNewDepartmentName] = useState('');
  const [isAdding, setIsAdding] = useState(false);

  const handleAddDepartment = async (e) => {
    e.preventDefault();
    if (!newDepartmentName.trim()) return;
    
    setIsAdding(true);
    try {
      await addDepartment(newDepartmentName);
      setNewDepartmentName('');
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <div className="department-list-page">
      <h1>{t('title')}</h1>
      <p>{t('manageDepartmentsDescription')}</p>
      
      {error && <div className="error-message">{error}</div>}
      
      {loading ? (
        <div className="loading">{t('loadingDepartments')}</div>
      ) : (
        <>
          <DepartmentList departments={departments} />
          
          <div className="add-department-form">
            <form onSubmit={handleAddDepartment}>
              <input
                type="text"
                placeholder={t('newDepartmentPlaceholder')}
                value={newDepartmentName}
                onChange={(e) => setNewDepartmentName(e.target.value)}
                disabled={isAdding}
              />
              <button type="submit" disabled={isAdding || !newDepartmentName.trim()}>
                {isAdding ? t('adding') : tCommon('buttons.add')}
              </button>
            </form>
          </div>
        </>
      )}
    </div>
  );
}

export default DepartmentListPage;